import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation, NavLink, Link } from "react-router-dom";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import { API_URL, ENDPOINTS } from "../constants/api";
import { getToken, decodeToken } from "../utils/TokenUtils";
import { useTranslation } from "react-i18next";
import { notification } from "antd";
import ModalForm from "./ModalForm";
import ReceiptForm from "./ReceiptForm";

const Sidebar = () => {
  const { t } = useTranslation();
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const navigate = useNavigate();
  const location = useLocation();

  // decode user/company info
  const companyName = decodeToken(token, "companyName");
  const companyLogo = decodeToken(token, "logo");
  const loginPage = decodeToken(token, "loginPage");

  const [categories, setCategories] = useState([]);
  const [links, setLinks] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [activeCategory, setActiveCategory] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({
      userId: null,
      token: null,
      route: null,
    });
    
  useEffect(() => {
    let linksUrl;
        console.log("company name : ",companyName)
        
        if (companyName.toLowerCase().includes('imaam') && companyName.toLowerCase().includes('shaafici')) {
          linksUrl = `${API_URL}/${ENDPOINTS.SYS}/get-categories2`;
        }else{
        linksUrl = `${API_URL}/${ENDPOINTS.SYS}/get-categories`;
        }

    const fetchLinks = async () => {
      try {
        const response = await axios.get(linksUrl, {
          headers: { Authorization: token ? `Bearer ${token}` : "" },
        });
        setCategories(response.data.categories);
        setLinks(response.data.links);
      } catch (error) {
        notification.error({
          message: `Error ${error?.response?.status}: ${
            error?.response?.data.message || "Unknown error"
          }`,
        });
      }
    };

    fetchLinks();
  }, [token]);

  const toggleCategory = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    setActiveCategory(id); // set selected category
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await axios.get(`${API_URL}/api/users/logout`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      localStorage.removeItem("authToken");
      navigate(`/login/${loginPage}`);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div
        className="d-flex flex-column flex-shrink-0 bg-light"
        style={{
          width: "300px",
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          overflowY: "auto",
        }}
      >
        <div className="p-3 text-center border-bottom">
          <img
            src={`${API_URL}/${companyLogo}`}
            alt="Company Logo"
            width="60"
            height="60"
            className="rounded-circle mb-2"
          />
          <h5>{companyName}</h5>
        </div>

        <ul className="nav nav-pills flex-column mb-auto">
          {categories &&
            categories.map((cat) => {
              const catLinks = links.filter(
                (l) => l.category_id === cat.category_id
              );
              if (catLinks.length === 0) return null;

              const isExpanded = expanded[cat.category_id];
              const isActiveCat = activeCategory === cat.category_id;

              return (
                <li key={cat.category_id} className="nav-item">
                  <button
                    className="nav-link d-flex align-items-center w-100"
                    onClick={() => toggleCategory(cat.category_id)}
                    style={{
                      color: isActiveCat ? "#fff" : "black",
                      background: isActiveCat ? "#007bff" : "none",
                      borderRadius: "5px",
                      fontSize: "18px",
                      paddingTop: "10px",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      border: "none",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <FeatherIcon icon={cat.category_icon} className="me-2" />
                      {t(cat.category)}
                    </span>                   
                    <span
                     
                    >
                    <span style={{paddingRight:"5px" }}>{catLinks.filter((l)=>l.category_id===cat.category_id).length}</span>
                    <span style={{
                        display: "inline-block",
                        transition: "transform 0.2s ease",
                        transform: isExpanded
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                        fontSize: "18px",
                      }}> ▶ </span>
                    </span>
                  </button>

                  {isExpanded && (
                    <ul
                      style={{
                        listStyle: "none",
                        marginLeft: "2rem",
                        padding: 0,
                      }}
                    >
                      {catLinks.map((link) => (
                        <li key={link.id} style={{ marginBottom: "8px" }}>
                          <NavLink
                            to={`/${link.full_route}`}
                             onClick={() => {
                                if (link.full_route.includes('-modal')) {
                                const route=link.route;
                                setModalProps({ userId, token, route });
                                setIsModalOpen(true);
                                } else {
                              
                              }
                              }}
                            style={({ isActive }) => ({
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              textDecoration: "none",
                              borderRadius: "4px",
                              
                              padding: "10px",
                              backgroundColor: isActive
                                ? "#28a745"
                                : "transparent", // green when active
                              color: isActive ? "#fff" : "#272626ff",
                              transition: "all 0.2s ease",
                              
                            })}
                          >
                            <span
                              style={{
                                marginRight: "8px",
                                fontSize: "16px",
                                color: "inherit",
                              }}
                            >
                              ▹
                            </span>
                            {t(link.name)}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
        </ul>
      </div>

      {/* Main Content */}
      <div style={{ marginLeft: "20px", marginTop: "10px", flex: 1 }}>
        <Outlet />
      </div>
       {/* ModalForm component */}
      {isModalOpen && modalProps?.route && (
        modalProps.route==='new-receipt2' ?
        <ReceiptForm
          userId={modalProps.userId}
          token={modalProps.token}
          route={modalProps.route}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
        :
        <ModalForm
          userId={modalProps.userId}
          token={modalProps.token}
          route={modalProps.route}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}
    </div>
  );
};

export default Sidebar;
